import { type ReactNode, useRef } from 'react';
import { YTIframe } from './required-video-iframe';
import { useYTAdapter } from '@/hooks/use-required-video-yt';
import type { RequiredVideoState } from '@/hooks/use-required-video';

type Props = { videoId: string; state: RequiredVideoState };

export function RequiredVideoYTPlayer({ videoId, state }: Props): ReactNode {
  const ref = useRef<HTMLIFrameElement>(null);
  useYTAdapter({
    iframeRef: ref,
    onReady: state.onReady,
    onTime: state.onTime,
  });
  return <YTIframe videoId={videoId} innerRef={ref} />;
}
